import { render, staticRenderFns } from "./@PopuMasterBranch.vue?vue&type=template&id=7584f090&"
import script from "./@PopuMasterBranch.vue?vue&type=script&lang=js&"
export * from "./@PopuMasterBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports